import { render, staticRenderFns } from "./courseArrange.vue?vue&type=template&id=31e553c3&scoped=true"
import script from "./courseArrange.vue?vue&type=script&lang=js"
export * from "./courseArrange.vue?vue&type=script&lang=js"
import style0 from "./courseArrange.vue?vue&type=style&index=0&id=31e553c3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31e553c3",
  null
  
)

export default component.exports